module.exports = __webpack_public_path__ + "img/img-no-igredient-candidate.972fd501.png";